/* eslint-disable @typescript-eslint/prefer-for-of */
/* components/CollectionSorting
- Used within collection and search templates
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { FakeDropdown } from '@/components/FakeDropdown/FakeDropdown';

@Component
export class VoyadoCollectionMobileActions extends ThemeComponent {
    @Ref viewToggle!: HTMLButtonElement;
    cookieName = 'ProductGrid';

    init() {
        this.clickEvents();
        window.addEventListener('load', () => {
            this.checkView();
            setTimeout(() => {document.dispatchEvent(new Event('gridSwitchLoaded'));}, 200);
        });
    }

    clickEvents() {
        this.$listen(this.viewToggle, 'click', () => {
            this.changeView();
        });
    }

    checkView() {
        const cookieValue = this.checkCookie();

        if (cookieValue) {
            this.viewToggle.classList.add('small-active');
            document.body.classList.add('grid-small');
        } else {
            this.viewToggle.classList.remove('small-active');
            document.body.classList.remove('grid-small');
        }
    }

    changeView() {
        const cookieValue = this.checkCookie();

        if (!cookieValue) {
            this.viewToggle.classList.add('small-active');
            document.body.classList.add('grid-small');
            this.setCookie(this.cookieName, 'true', 7);
        } else {
            this.viewToggle.classList.remove('small-active');
            document.body.classList.remove('grid-small');
            this.deleteCookie(this.cookieName);
        }
    }

    setCookie(cookieName: string, cookieValue: string, daysToExpire: number) {
        const date = new Date();
        date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    }

    deleteCookie(cookieName: string) {
        const date = new Date();
        date.setTime(date.getTime() - 1);
        const expires = "expires=" + date.toUTCString();
        document.cookie = cookieName + "=;" + expires + ";path=/";
    }

    checkCookie() {
        const cookieName = 'ProductGrid';

        const cookieValue = this.getCookie(cookieName);

        if (cookieValue === 'true') {
            return true;
        } else {
            return false;
        }
    }

    getCookie(cookieName: string): string | null {
        const name = cookieName + "=";
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return null;
    }
}
